import { Crop } from './crop';
import { FieldActivity } from './fieldActivity';
import { Container } from './container';
import { TenantGeneralData } from './tenantGeneralData';

export class FieldActivityItem extends TenantGeneralData {
  name: string;
  quantity: number;
  unit: string;
  description: string;
  note: string;
  dateCreated: Date;
  lastUpdated: Date;
  fieldActivity: FieldActivity;
  cropId?: Crop;
  container: Container;
  humidity?: number;

  constructor() {
    super();
    this.id = null;
    this.name = null;
    this.quantity = null;
    this.unit = 'kg';
    this.description = null;
    this.note = null;
    this.dateCreated = null;
    this.lastUpdated = null;
    this.fieldActivity = null;
    this.cropId = null;
    this.container = null;
    this.humidity = null;
  }
}
